module.exports = __webpack_public_path__ + "img/banner2.6bb66613.png";